<div *ngIf="show" class="payment-form-modal" (click)="onOverlayClick($event)">
  <div class="modal-overlay"></div>
  <div class="modal-content">
    <div class="modal-header">
      <h3>
        <i class="fas fa-dollar-sign"></i>
        Registrar Pago de Matrícula
      </h3>
      <button class="close-btn" (click)="onClose()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <!-- Student Info Card -->
      <div class="student-info-card">
        <div class="info-row">
          <span class="label">Registro:</span>
          <span class="value">#{{ itfRecord.id }}</span>
        </div>
        <div class="info-row">
          <span class="label">Nombre:</span>
          <span class="value">{{ itfRecord.apellido }}, {{ itfRecord.nombre }}</span>
        </div>
        <div class="info-row" *ngIf="itfRecord.nroLibreta">
          <span class="label">Nro. Libreta:</span>
          <span class="value">{{ itfRecord.nroLibreta }}</span>
        </div>
      </div>

      <div *ngIf="error" class="alert alert-error">
        <i class="fas fa-exclamation-triangle"></i>
        {{ error }}
      </div>

      <div class="form-group">
        <label>Año <span class="required">*</span></label>
        <input 
          type="number" 
          [(ngModel)]="newPayment.anio"
          placeholder="2024"
          min="2020"
          max="2100"
          class="form-control">
      </div>

      <div class="form-group">
        <label>Fecha de Pago <span class="required">*</span></label>
        <input 
          type="date" 
          [(ngModel)]="newPayment.fechaPago"
          class="form-control">
      </div>

      <div class="form-group">
        <label>Monto <span class="required">*</span></label>
        <input 
          type="number" 
          [(ngModel)]="newPayment.monto"
          placeholder="20000"
          min="0"
          step="10"
          class="form-control">
      </div>

      <div class="form-group">
        <label>Método de Pago</label>
        <select [(ngModel)]="newPayment.metodoPago" class="form-control">
          <option *ngFor="let metodo of paymentMethods" [value]="metodo">
            {{ metodo }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label>Notas</label>
        <textarea 
          [(ngModel)]="newPayment.notas"
          placeholder="Notas adicionales (opcional)"
          rows="3"
          class="form-control"></textarea>
      </div>
    </div>

    <div class="modal-footer">
      <button 
        (click)="onClose()" 
        class="btn-secondary"
        type="button"
        [disabled]="isSaving">
        <i class="fas fa-times"></i>
        Cancelar
      </button>
      <button 
        (click)="registrarPago()" 
        class="btn-primary"
        type="button"
        [disabled]="isSaving">
        <i class="fas fa-save"></i>
        {{ isSaving ? 'Guardando...' : 'Registrar Pago' }}
      </button>
    </div>
  </div>
</div>